import { render, staticRenderFns } from "./changeLiveCode.vue?vue&type=template&id=1b2ed4da&scoped=true"
import script from "./changeLiveCode.vue?vue&type=script&lang=js"
export * from "./changeLiveCode.vue?vue&type=script&lang=js"
import style0 from "./changeLiveCode.vue?vue&type=style&index=0&id=1b2ed4da&prod&lang=less&scoped=true"
import style1 from "./changeLiveCode.vue?vue&type=style&index=1&id=1b2ed4da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ed4da",
  null
  
)

export default component.exports